import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GridConfigApi } from '../api/grid-config.api';
import { GridConfigName } from '../utils/enums/grid-config.enum';
import { MACHINE_GRID_CONFIG_DEFAULT } from '../utils/constants/machines.const';
import { TENANT_GRID_CONFIG_DEFAULT } from '../utils/constants/tenant.const';
import { USER_GRID_CONFIG_DEFAULT } from '../utils/constants/users.const';
import { GridConfig } from '../utils/models/grid-config.model';

@Injectable({
  providedIn: 'root',
})
export class GridConfigService {
  private readonly gridConfigApi = inject(GridConfigApi);

  private _gridConfig$ = new BehaviorSubject<GridConfig>({
    displayedColumns: [],
    columnOrder: [],
    columnsWidths: {},
  });

  private _defaultConfigs: Record<GridConfigName, GridConfig> = {
    [GridConfigName.MachineGridConfig]: MACHINE_GRID_CONFIG_DEFAULT,
    [GridConfigName.TenantGridConfig]: TENANT_GRID_CONFIG_DEFAULT,
    [GridConfigName.UserGridConfig]: USER_GRID_CONFIG_DEFAULT,
  };

  public get gridConfig$(): Observable<GridConfig> {
    return this._gridConfig$.asObservable();
  }

  public loadGridConfig(gridName: GridConfigName): void {
    const defaultGridConfig = this._defaultConfigs[gridName];
    const gridConfig = this.gridConfigApi.getGridConfig(gridName, defaultGridConfig);
    this._gridConfig$.next(gridConfig);
  }

  public saveGridConfig(name: GridConfigName, gridConfig: GridConfig): void {
    this.gridConfigApi.setGridConfig(name, gridConfig);
    this._gridConfig$.next(gridConfig);
  }
}
